// extracted by mini-css-extract-plugin
export default {"aside":"aside_aside__ED31n","collapsed":"aside_collapsed__Pnp86","expanded":"aside_expanded__yw238","buttonGroup":"aside_buttonGroup__pybSl"};